export default "__VITE_ASSET__Dgp2z5KQ__"